<template>
<div>
    <div class="container">
        <div class="space-100"></div>
        <div class="row">
          <h2 class="is-not-resposive-transaction title-resp"><strong>Transacciones </strong></h2>
          <router-link class="nav-link is-not-resposive-transaction nav-link-resp"  to="/PerfilUsuario">
            <button class="back-btn">
              <a class="is-not-resposive-transaction ">Regresar</a>
            </button>
          </router-link>
        </div>
        <div class="row">
            <div class="col-sm-4">
                <div>
                    <h2>Buscar</h2>
                </div>
                <div>
                    <form action="">  
                        <p class="inputs-title">Comercio</p>
                        <select v-model="merchant" @change="searchOfficeMerchantOption()" class="inputs" name="" id="">
                          <option value="">Elija un Comercio</option>
                          <option :value="item.id_comercio" v-for="item of commersOption" :key="item.commer">{{item.nombre}}</option>
                        </select>
                        <p class="inputs-title">Sucursal</p>
                        <select v-model="office" class="inputs" name="" id="">
                          <option value="">Elija una Sucursal</option>
                          <option :value="item.id_sucursal" v-for="item of OfficeMerchantOption" :key="item.OfficeMerchant">{{item.nombre}}</option>
                        </select>
                        <p class="inputs-title">Fecha</p>
                        <div class="date-picker-style block">
                          <el-date-picker v-model="date" type="daterange" start-placeholder="Desde" end-placeholder="Hasta">
                          </el-date-picker>
                        </div>
                    </form>
                </div>
                <div class="text-center">
                    <button class="redimir-button" @click="searchTransacctions()">Buscar</button>
                </div>
            </div>
            <div class="col-sm-8">
                <div class="row is-resposive-transaction">
                    <div class="col-sm-9">
                        <h2 class="is-resposive-transaction"><strong>Transacciones </strong></h2>
                    </div>
                    <div class="col-sm-3 text-right">
                      <router-link class="is-resposive-transaction"  to="/PerfilUsuario">
                        <button class="back-btn">
                          <p class="back-btn-txt">Regresar</p>
                        </button>
                      </router-link>
                    </div>
                </div>
                <div>
                    <div class="row justify-content-center table-scroll">
                        <table class="text-center table-style ">
                            <tr>
                              <th class="blue-A">Id</th>
                              <th class="blue-B">Comercio</th> 
                              <th class="blue-A">Sucursales</th>
                              <th class="blue-B">Referencias</th>
                              <th class="blue-A">Total</th>
                              <th class="blue-B">Puntos</th>
                              <th class="blue-A">Saldo</th>
                              <th class="blue-B">Fecha</th>
                            </tr>
                            <tr class="all-trasacction-table-body" v-for="transaction of allTransactions.results" :key="transaction.transac">
                              <th>{{transaction.id_transaccion}}</th> 
                              <th>{{transaction.comercio}}</th>
                              <th>{{transaction.sucursal}}</th>
                              <th>{{transaction.referencia}}</th>
                              <th>{{transaction.total}}</th>
                              <th>{{transaction.puntos}}pts</th>
                              <th>${{transaction.puntos}}</th>
                              <th>{{transaction.fecha}}</th>
                            </tr>
                        </table>
                        <div v-if="showLoader" class="text-center">
                          <img src="../../public/img/Rolling-1s-200px.gif">
                        </div>
                        <div class="empty-transactions" v-if="emptyTransactions">
                          <h3>No hay transacciones</h3>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-sm-7">
                        <p class="info-results">Mostrando <strong>26</strong> resultados de <strong>123</strong></p>
                    </div>
                    <div class="col-sm-5">
                        <n-pagination class="pagination-style" type="default" :page-count="3" v-model="pagination.default"></n-pagination>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { Card, FormGroupInput, Button, Pagination} from '@/components';
import ProfileService from '../service/core/profile.service'
import {DatePicker} from 'element-ui'
import VueRangedatePicker from 'vue-rangedate-picker'
import moment from 'moment';


export default {
  components: {
    Card,
    VueRangedatePicker,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Pagination.name]: Pagination,
  },
  data(){
    return {
      profileService: new ProfileService(),
      allTransactions: '',
      commersOption: '',
      OfficeMerchantOption: '',
      merchant: '',
      office: '',
      date: '',
      showFiltersSelected: false,
      emptyTransactions: false,
      showLoader: false,
      pagination: {
        simple: 1,
        default: 2,
        full: 3
      }
    }
  },
  mounted(){
    this.merchantsOptions()
    this.showAllTransaction()
  },
  methods:{
    merchantsOptions(){
      this.profileService.searchCommerce().then(data => {
       this.commersOption =  data.data.results
      }, err => {
      
      })
    },
    searchOfficeMerchantOption(){
      let conditions = {
        'conditions':{
          "merchant": this.merchant
        }
      }
      this.profileService.searchOfficeMerchant(conditions).then(data => {
        this.OfficeMerchantOption =  data.data.results
      }, err => {
      
      })
    },
    showAllTransaction(){
      this.showLoader = true
      let conditions = {
        "conditions":{}
      }
      this.profileService.searchTransactions(conditions).then(data => {
        console.log(data)
        this.showLoader = false
        this.allTransactions = data.data
      }, err => {
      
      })
    },
    searchTransacctions(){
      this.showFiltersSelected = true
      let conditions = {
        "conditions":{}
      }
      if(this.merchant !== ''){
        conditions['conditions']['merchant'] = this.merchant
      }
      if(this.office !== ''){
        conditions['conditions']['office'] = this.office
      }
      if(this.date !== ''){
        conditions['conditions']['date_from'] = moment(this.date[0]).format('YYYY-MM-DD')
        conditions['conditions']['date_until'] = moment(this.date[1]).format('YYYY-MM-DD')
      }
      this.profileService.searchTransactions(conditions).then(data => {
        this.allTransactions = data.data  
        if(this.allTransactions.results.length === 0){
          this.emptyTransactions = true
        }else{
          this.emptyTransactions = false
        }
      }, err => {
      
      })
    }
  }
}
</script>
<style>
.margin-defult{
    margin: 0px;
}
.redimir-button{
    width: 50%;
    height: 40px;
    color: white;
    margin: 10px;
    font-size: 17px;
    background-color: #00bbff; 
    border-radius: 21px 21px 21px 21px;
    -moz-border-radius: 21px 21px 21px 21px;
    -webkit-border-radius: 21px 21px 21px 21px;
    border: 0px solid #ffffff;
}
.text-color{
    color: #818181;
}
.borders-defult{
    width: 23%;
    padding: 5px;
    margin: 8px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #000000;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.5);
}
.cupon-img{
    padding: 30px 5px 30px 5px;
}
.validity-date{
    margin: 0px;
    font-size: 10px;
    padding-left: 140px;
}
.inputs-calendar{
  width: 80%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.inputs{
  width: 88%;
  padding: 5px;
  background-color: white;
  margin: 10px;
  border: 1px;
  border-bottom: 2px solid #ECECEC;
}
.checkbox-style{
    margin: 10px;
}
.inputs-title{
    width: 90%;
    margin: 10px 10px -13px 10px;
    font-size: 10px;
}
.calendar-icon{    
    padding: 0px 0px 5px 0px;
    background-color: white;
    margin-left: -10px;
    border: 1px;
    border-bottom: 2px solid #ECECEC;
}

.date-picker-info{
  border: 0px;
}
.download-button{
    color: rgb(156, 156, 156);
    height: 30px;
    margin: 0px 25px 25px 10px;
    padding: 2px 10px 2px 10px;
    font-size: 12px;
    background-color: #dddddd; 
    border-radius: 21px 21px 21px 21px;
    -moz-border-radius: 21px 21px 21px 21px;
    -webkit-border-radius: 21px 21px 21px 21px;
    border: 0px solid #ffffff;
}
.icon-download{
    width: 15px;
    margin: 5px; 
}
.blue-A{
    width: 100px;
    padding: 10px;
    color: #ffffff;
    background-color: #268fc6;
}
.blue-B{
    width: 100px;
    color: #ffffff;
    background-color: #37a8de;    
}
.table-style{
    width: 100%;
}
.table-data{
    border-bottom: 2px solid #ECECEC;
}
.info-results{
    margin-top: 10px;
}
.pagination-style{
    margin: 10px 0px 0px 50px;
}

table{
  width: 100%;
  border: 0px solid black;

}

.all-trasacction-table-body{
  font-size: 12px
}

.date-picker-style{
  margin: 20px 10px;
  width: 90%;
}

.filter-selected-button{
  background-color: #37a9de00;
  border: 0px;
}
.filter-selected-item{
  padding: 5px;
  margin: 0px 10px 10px 0px;
  background-color: #37a9de00;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #37a9de00;
}
.empty-transactions{
  margin: 40px;
}

.is-not-resposive-transaction{
  display: none;
}

.back-btn{
  width: 100px;
  height: 40px;
  color: #ffffff;
  margin: 10px;
  font-size: 17px;
  background-color: #00bbff; 
  border-radius: 21px 21px 21px 21px;
  -moz-border-radius: 21px 21px 21px 21px;
  -webkit-border-radius: 21px 21px 21px 21px;
  border: 0px solid #ffffff;
}
.{
  color: #ffffff;
  font-size: 15px;
}
.:hover{
  color: #ffffff;
  font-size: 15px;
}
@media screen and (min-width: 321px) and (max-width: 768px) { 
    table{
    border-collapse: collapse;
    width: 100%;
    border: 1px solid black;
  
  }
  
  th{
    border: 2px solid #ffffff;
  }
  
  td {
    border: 2px solid #ffffff;
    padding: 10px;
  }
  .table-scroll{
    max-height: 100%;
    overflow: auto;	
    padding-left: 320px;
  }
  .is-not-resposive-transaction{
    display: block;
    text-align: center;
  }
  .is-resposive-transaction{
    display: none;
  }
  .title-resp{
    padding-left: 50px;
  }
  .nav-link-resp{
    width: 100%;
    padding-left: 500px;
    margin-top: -30px;
  }
}
</style>
